import { SizedBox } from "@/components/core/SizedBox";
import { TopBanner } from "@/pages/Blog/TopBanner";
import { BlogGrid } from "@/pages/Blog/BlogGrid";


const BlogHome = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "var(--color-bg)",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    padding: '20px',
                    maxWidth: "1100px",
                    width: '100%',
                }}
            >
                <TopBanner />
                <SizedBox height={20} />
                <BlogGrid />
                <SizedBox height={10} />
            </div>
        </div>
    );
};

export default BlogHome;
